import { render } from "./AgentAddEdit.vue?vue&type=template&id=2a67a0ce&scoped=true"
import script from "./AgentAddEdit.vue?vue&type=script&lang=js"
export * from "./AgentAddEdit.vue?vue&type=script&lang=js"

import "./AgentAddEdit.vue?vue&type=style&index=0&id=2a67a0ce&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\Tracker Eticket\\Tracker_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a67a0ce"]])

export default __exports__